import { useTranslation } from 'react-i18next';
import type { CleaningNextArrivalResponse } from '@/shared/api';
import { cleaningPreparationLabel } from '../CleaningPreparationSummary';
import { cleaningOccupancySummary } from '../cleaningOccupancy';

/**
 * Nächste Gäste und — nur wenn die Aufgabe ohne Fotos abgeschlossen wird — die optionale Notiz zum
 * Abschluss; erledigt steht dort die gespeicherte Notiz.
 */
export function FinishCard({
  arrival,
  notes,
  completionNotes,
  onNotes,
}: {
  arrival: CleaningNextArrivalResponse | null;
  /** null = kein Feld (mit Fotos, schon erledigt oder ohne Recht). */
  notes: string | null;
  completionNotes: string | null;
  onNotes: (notes: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <section className="border-hairline rounded-tile flex flex-col gap-2 border bg-white p-3.5">
      <p className="text-ink-soft text-[13px]">
        <b className="text-ink">Nächste Gäste:</b> {cleaningOccupancySummary(arrival)} ·{' '}
        {cleaningPreparationLabel(arrival, t)}
      </p>
      {notes !== null && (
        <label className="flex flex-col gap-1.5">
          <span className="text-[13px] font-bold">
            Notiz zum Abschluss <span className="text-ink-soft font-medium">· optional</span>
          </span>
          <textarea
            value={notes}
            onChange={(event) => onNotes(event.target.value)}
            rows={2}
            maxLength={2000}
            placeholder="z. B. Spülmaschine läuft noch"
            className="border-line rounded-control focus-visible:outline-forest min-h-16 border-[1.5px] px-3 py-2.5 text-sm"
          />
        </label>
      )}
      {completionNotes && (
        <p className="text-[13px]">
          <b>Notiz zum Abschluss:</b> {completionNotes}
        </p>
      )}
    </section>
  );
}
